import { withRouter } from 'react-router';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { compose, setDisplayName, onlyUpdateForKeys, withProps } from 'recompose';
import * as React from 'react';
import { withClassname } from '@components/hoc/withClassname';
import { PeriodsForm } from '@modules/hr-templates/periods/PeriodsForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const periodsUrl = '/metropolis/api/hr/workplan/calendar/period';
export const periodsLabel = 'Personalistika - intervaly';
export const periodsPath = '/hr/templates/periods';
export const periodsGridName = 'PeriodsGrid';
export const PeriodsGrid = compose(
  withRouter,
  setDisplayName(periodsGridName),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: periodsLabel }]),
  withColumns(Agenda.PERIODS),
  withProps(({ columns }) => ({
    name: periodsGridName,
    url: periodsUrl,
    Form: PeriodsForm,
    dialog: false,
    gridProps: {
      columns,
      filterRow: true,
      showCheckboxes: true,
      deleting: true,
      filtering: true,
      locale: 'cz',
      adding: true,
      version: 7,
      closeOnSave: false,
      ActionBar: () => <ColumnManager agenda={Agenda.PERIODS} />
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/hr-templates/periods/PeriodsGrid.tsx